import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad_8BRed_8CRed_8DBlue = () => <CrossRoad coords="2126.000000, 804.694374"/>;
export default CrossRoad_8BRed_8CRed_8DBlue;
